import React, { useState, useEffect } from 'react';
import { WifiIcon } from '@heroicons/react/24/outline';

export default function ConnectivityBanner() {
  const [status, setStatus] = useState(navigator.onLine ? 'online' : 'offline');

  useEffect(() => {
    const handleOnline = () => setStatus('online');
    const handleOffline = () => setStatus('offline');

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (status === 'online') return null;

  return (
    <div className="bg-red-50 border-b border-red-200 px-4 py-2 flex items-center gap-2 text-sm text-red-800">
      <WifiIcon className="h-4 w-4" />
      <span>You are offline. Changes will sync when connection is restored.</span>
    </div>
  );
}
